/*
 * Normalize doc after undo..
 *
 * There seems to be a bug in Slate (v0.31.8) where,
 * selecting all + delete + undo will result in the last
 * block of the doc also becoming a headline.
 *
 * Probably temporary validation rule to sanitize this. :\
 * Also, focus() after undo+normalize call.
 */
export const PatchUndo = (opts = {}) => ({
  onKeyDown(e, change, editor) {
    const {
      matcher = () => false,
    } = opts

    const isMatched = matcher(e);
    if (!isMatched) return;

    const c = change.undo().normalizeDocument().focus();
    // console.log(c)
    return c;
  }
});



// WEBPACK FOOTER //
// ./src/components/slate/plugins/PatchUndo.js